module.exports = __webpack_public_path__ + "media/images/icons/mascot/3-9869b3bf780c81f9ff810bb2735737be.png";